<template>
    <div class="search inline-block">
        <div class="search-text pull-left">
            <div class="m-l-sm">
                <input aria-label="search" type="text" :placeholder="t_search" v-model="search" class="form-control" style="height: 36px;">
            </div>
        </div>

        <div class="search-group pull-left">
            <div class="m-l-sm">
                <chosen-multiselect id="select-groups" class="form-group" :trans-placeholder-multi="t_groups" v-model="groups" :placeholder="t_groups">
                    <option v-for="data in fullGroupList.data"
                            :value="data.id">{{data.name}}</option>
                </chosen-multiselect>
            </div>
        </div>

        <div class="search-location pull-left">
            <div class="m-l-sm">
                <chosen-multiselect id="select-locations" class="form-group" :trans-placeholder-multi="t_locations" v-model="locations">
                    <option v-for="data in fullLocationList.data"
                            :value="data.id">{{data.name}}</option>
                </chosen-multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import toaster from "../../common/toaster";
    import fixAriaTag from "../searchBarWorkaround";

    export default {
        data: function () {
            return {
                t_search: Lang.langGet('Search'),
                t_groups: Lang.langChoice('Screengroup|Screengroups', 2),
                t_load_groups_failed: Lang.langGet('Failed to load screengroups.'),
                t_locations: Lang.langChoice('Location|Locations', 2),
                t_load_locations_failed: Lang.langGet('Locations could not be loaded.'),

                search: '',
                groups: [],
                locations: [],

                fullGroupList: {
                    data: []
                },
                fullLocationList: {
                    data: []
                },
            }
        },
        watch: {
            search: debounce(function () {
                EaseEventBus.fire('fetchScreenshots', {
                    keyword: this.search,
                    groups: this.groups,
                    locations: this.locations
                });
            }, 500),
            groups: function () {
                EaseEventBus.fire('fetchScreenshots', {
                    keyword: this.search,
                    groups: this.groups,
                    locations: this.locations
                });
            },
            locations: function () {
                EaseEventBus.fire('fetchScreenshots', {
                    keyword: this.search,
                    groups: this.groups,
                    locations: this.locations
                });
            }
        },
        methods: {
            loadGroups: function () {
                if (this.fullGroupList.data.length > 0) {
                    return;
                }

                axios.post('/administration/project/loadscreengroups', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.fullGroupList.data = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(this.t_load_groups_failed);
                });
            },
            loadLocations: function () {
                if (this.fullLocationList.data.length > 0) {
                    return;
                }

                axios.post('/administration/project/loadlocations', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.fullLocationList.data = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(this.t_load_locations_failed);
                });
            },
        },
        mounted() {
            this.loadGroups();
            this.loadLocations();
            EaseEventBus.listen('startScreenshotSearch', () => {
                EaseEventBus.fire('fetchScreenshots', {
                    keyword: this.search,
                    groups: this.groups,
                    locations: this.locations
                });
            });

            fixAriaTag($(this.$el));
        }
    }
</script>

<style scoped>
    .inline-block {
        padding-right: 10pt;
    }

    .search .search-text {
        width: 200px;
    }
    .search .search-group {
        width: 350px;
    }
    .search .search-location {
        width: 350px;
    }
</style>
